import { Line } from 'vue-chartjs'
import 'chartjs-adapter-date-fns'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    TimeScale,
    Filler,
    Decimation
} from 'chart.js'
import zoomPlugin from 'chartjs-plugin-zoom'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    TimeScale,
    Filler,
    Decimation,
    zoomPlugin
)

export default {
    name: 'LineChart',
    props: {
        chartData: {
            type: Object,
            required: false,
            default: () => ({ labels: [], datasets: [] })
        },
        options: {
            type: Object,
            required: false,
            default: () => ({})
        },
        height: {
            type: [Number, String],
            default: null
        },
        width: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            internalData: null,
            internalOptions: null
        }
    },
    computed: {
        activeData() {
            const data = this.internalData || this.chartData
            return this.addDefaultTension(data)
        },
        activeOptions() {
            return this.internalOptions || this.options
        }
    },
    render(h) {
        // Create wrapper div with explicit height for maintainAspectRatio: false to work
        const containerStyle = {
            position: 'relative',
            width: this.width
                ? (typeof this.width === 'number' ? `${this.width}px` : this.width)
                : '100%',
            height: this.height
                ? (typeof this.height === 'number' ? `${this.height}px` : this.height)
                : '100%'
        }
        // vue-chartjs v4 props
        const props = {
            chartData: this.activeData,
            chartOptions: this.activeOptions,
            styles: { height: '100%', width: '100%' }
        }
        return h('div', { style: containerStyle }, [
            h(Line, {
                props,
                ref: 'lineChart'
            })
        ])
    },
    methods: {
        addDefaultTension(data) {
            if (!data || !data.datasets) return data

            return {
                ...data,
                datasets: data.datasets.map(dataset => ({
                    tension: 0.4, // Default curve tension for smooth lines
                    ...dataset
                }))
            }
        },
        // Backwards compatibility method - existing code calls this
        renderChart(data, options) {
            this.internalData = data
            this.internalOptions = options
            // Force re-render
            this.$forceUpdate()
        },
        // Get the underlying Chart.js instance
        getChartInstance() {
            const lineComponent = this.$refs.lineChart
            if (lineComponent && lineComponent.chart) {
                return lineComponent.chart
            }
            return null
        },
        // Reset zoom on the chart
        resetZoom() {
            const chart = this.getChartInstance()
            if (chart && chart.resetZoom) {
                chart.resetZoom()
            }
        }
    }
}
